import { getToken } from "../../../functions/localStorage";
import { POST_METHOD, GET_METHOD } from "../../axiosMethod";


const getHeaders = (token) => ({
  Authroization: token ?? getToken(),
});

export const loginApi = async (payload) => {
  try {
    const data = await POST_METHOD("auth/login", payload, {
      Headers: getHeaders(),
    });
    return data
  } catch (error) {
    return {
      data: error?.response?.data
    }
  }
};

export const checkEmailAndPassword = async (payload) => {
  try {
    const data = await POST_METHOD("auth/email-password-check", payload, {
      Headers: getHeaders(),
    });
    return data
  } catch (error) {
    return {
      data: error?.response?.data
    }
  }
};

export const forgotPassApi = async (payload) => {
  try {
    const data = await POST_METHOD("auth/forgot-password", payload, {
      Headers: getHeaders(),
    });
    return data
  } catch (error) {
    return {
      data: error?.response?.data
    }
  }
};

export const resetPassApi = async (payload) => {
  try {
    const data = await POST_METHOD("auth/reset-password", payload, {
      Headers: getHeaders(),
    });
    return data
  } catch (error) {
    return {
      data: error?.response?.data
    }
  }
};

export const verifyTokenApi = async (payload) => {
  try {
    const data = await GET_METHOD("auth/verify-token", {
      Headers: getHeaders(),
      params: payload
    });
    return data
  } catch (error) {
    return {
      data: error?.response?.data
    }
  }
};

